module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/116-curacao-4c0010f6a70c2afc8d0ca97e7a1ec50f.svg";